import { createUseStyles } from 'react-jss';

import { FontWeight, mediaQuery } from '../../../styles';
import { ITheme } from '../../../styles/theme';

const useStyles = createUseStyles<string, { noBoxShadow: boolean }>(
  ({ breakpoints, layout }: ITheme) => ({
    root: {
      background: `linear-gradient(to bottom, ${layout.background}, ${layout.background})`,
      backgroundPosition: '0 0',
      backgroundRepeat: 'no-repeat',
      backgroundSize: '100%',

      textAlign: 'center',
      marginBottom: 40,
      padding: '0 60px 48px 60px',

      '&.partialBg': {
        backgroundSize: '100% 70%',
      },

      [mediaQuery(breakpoints.tablet)]: {
        padding: '20px 24px 40px',
      },
    },
    breadcrumb: {
      paddingBottom: 18,
    },
    header: {
      padding: '48px 32px 40px 32px !important',

      [mediaQuery(breakpoints.tablet)]: {
        padding: '32px !important',
      },
    },
    headerComponent: {
      marginBottom: 20,
    },
    banner: {
      maxWidth: layout.maxWidth,
      margin: 'auto',
      borderRadius: '16px',
      background: 'var(--x-bg-1)',
      boxShadow: ({ noBoxShadow }) => (noBoxShadow ? 'none' : '0 0 4px 0 var(--x-shadow-card)'),
      padding: '56px 32px 32px 32px',
      position: 'relative',

      [mediaQuery(breakpoints.tablet)]: {
        padding: [40, 24],
      },
    },
    alert: {
      position: 'absolute',
      top: 0,
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      width: '100%',
    },
    alertContainer: {
      width: '100%',
      maxWidth: '900px',
    },
    bannerContent: {
      maxWidth: '1000px',
      margin: 'auto',
    },
    imgContainer: {
      marginBottom: '41px',

      '& img': {
        maxWidth: '100%',
        verticalAlign: 'top',
        display: 'inline-block',
      },

      [mediaQuery(breakpoints.tablet)]: {
        marginBottom: '24px',
      },
    },
    heading: {
      fontSize: '42px',
      lineHeight: '50px',
      color: 'var(--x-black)',
      fontWeight: FontWeight.Medium,
      margin: '0 0 16px 0',

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 30,
        lineHeight: '36px',
      },
    },
    content: {
      fontSize: '16px',
      lineHeight: '24px',
      fontWeight: FontWeight.Medium,
      margin: '0 32px 32px',
      color: 'var(--x-black)',
    },
  }),
  {
    name: 'hero-banner',
  },
);

export default useStyles;
